import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <div className="App" style={{ paddingLeft: 100, paddingRight: 100 }}>
      <h1>PRIVACY POLICY FOR MOBILE APPLICATION BetterTalk </h1>
      <h4>
        BetterTalk IND built the BetterTalk app as a Free app. This SERVICE is
        provided by BetterTalk IND at no cost and is intended for use as is.
      </h4>
      <h4>
        This page is used to inform visitors regarding my policies with the
        collection, use, and disclosure of Personal Information if anyone
        decided to use my Service.
      </h4>
      <h4>
        If you choose to use my Service, then you agree to the collection and
        use of information in relation to this policy. The Personal Information
        that I collect is used for providing and improving the Service. I will
        not use or share your information with anyone except as described in
        this Privacy Policy.
      </h4>
      <h4>
        The terms used in this Privacy Policy have the same meanings as in our
        Terms and Conditions, which are accessible at BetterTalk unless
        otherwise defined in this Privacy Policy
      </h4>
      <h1>*Information Collection and Use*</h1>
      <h4>
        For a better experience, while using our Service, I may require you to
        provide us with certain personally identifiable information, including
        but not limited to Email,Phone number,age,location,first name, last
        name. The information that I request will be collected by us for a
        better app experience and to have a customer support base, this
        information will not be shared by any third party apps.
      </h4>
      <h4>
        The app does use third-party services that may collect information used
        to identify you.
      </h4>
      <h4>
        Link to the privacy policy of third-party service providers used by the
        app
      </h4>

      <a href="https://developers.google.com/android" target="_blank">
        <h4> Goolge Play Services</h4>
      </a>

      <a href="https://firebase.google.com/products/analytics" target="_blank">
        <h4> Google Analytics for Firebase</h4>
      </a>

      <a
        href="https://firebase.google.com/products/crashlytics"
        target="_blank"
      >
        <h4> Firebase Crashlytics</h4>
      </a>
      <h1>*Log Data*</h1>
      <h4>
        I want to inform you that whenever you use my Service, in a case of an
        error in the app I collect data and information (through third-party
        products) on your phone called Log Data. This Log Data may include
        information such as your device Internet Protocol (“IP”) address, device
        name, operating system version, the configuration of the app when
        utilizing my Service, the time and date of your use of the Service, and
        other statistics.
      </h4>
      <h1>*Cookies*</h1>
      <h4>
        Cookies are files with a small amount of data that are commonly used as
        anonymous unique identifiers. These are sent to your browser from the
        websites that you visit and are stored on your device's internal memory.
      </h4>
      <h4>
        This Service does not use these “cookies” explicitly. However, the app
        may use third-party code and libraries that use “cookies” to collect
        information and improve their services. You have the option to either
        accept or refuse these cookies and know when a cookie is being sent to
        your device. If you choose to refuse our cookies, you may not be able to
        use some portions of this Service.
      </h4>
      <h1>*Service Providers*</h1>
      <h4>
        I may employ third-party companies and individuals due to the following
        reasons:
      </h4>
      <ol>
        <li>To facilitate our Service</li>
        <li>To provide the Service on our behalf</li>
        <li> To perform Service-related services or</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ol>
      <h4>
        I want to inform users of this Service that these third parties have
        access to their Personal Information. The reason is to perform the tasks
        assigned to them on our behalf. However, they are obligated not to
        disclose or use the information for any other purpose.
      </h4>
      <h1>*Security*</h1>
      <h4>
        I value your trust in providing us your Personal Information, thus we
        are striving to use commercially acceptable means of protecting it. But
        remember that no method of transmission over the internet, or method of
        electronic storage is 100% secure and reliable, and I cannot guarantee
        its absolute security.
      </h4>
      <h1>*Links to Other Sites*</h1>
      <h4>
        This Service may contain links to other sites. If you click on a
        third-party link, you will be directed to that site. Note that these
        external sites are not operated by me. Therefore, I strongly advise you
        to review the Privacy Policy of these websites. I have no control over
        and assume no responsibility for the content, privacy policies, or
        practices of any third-party sites or services.
      </h4>
      <h1>*Audio and Video Call*</h1>
      <h4>
        There is a feature of both audio and video Call integrated into the app
        for the convenience of the users, The video and audio Call both are not
        recorded only the timings of the call made and duration of the call are
        saved.
        <ol>
          <li>
            Camera Will only be turned on when the user clicks on the video Call
            option.
          </li>
          <li>
            Audio will be only turned on when the user click the audio Call
            option
          </li>
          <li>
            The internal mic or default mic will be used for the audio call.
          </li>
          <li>
            The mic will only be used when a call is initiated and no other
            time.
          </li>
        </ol>
        <h1>*Chat*</h1>
        <h4>
          The internal Chat feature is totally private and is not shared with
          any third party application.
        </h4>
      </h4>
      <h1>*Children’s Privacy*</h1>
      <h4>
        These Services do not address anyone under the age of 13. I do not
        knowingly collect personally identifiable information from children
        under 13 years of age. In the case I discover that a child under 13 has
        provided me with personal information, I immediately delete this from
        our servers. If you are a parent or guardian and you are aware that your
        child has provided us with personal information, please contact me so
        that I will be able to do the necessary actions.
      </h4>
      <h1>*Changes to This Privacy Policy*</h1>
      <h4>
        I may update our Privacy Policy from time to time. Thus, you are advised
        to review this page periodically for any changes. I will notify you of
        any changes by posting the new Privacy Policy on this page. This policy
        is effective as of 2022-06-22
      </h4>
      <h1>*Contact Us*</h1>
      <h4>
        If you have any questions or suggestions about my Privacy Policy, do not
        hesitate to contact me at rahilyt18@gmail.
      </h4>
    </div>
  );
}

export default App;
